module.exports = __webpack_public_path__ + "img/topratedcoaches.855c6fc8.png";